module.exports = __webpack_public_path__ + "img/China.02ab0f42.svg";